import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext'; // On importe le moteur

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* On enveloppe l'App pour que l'Auth fonctionne partout */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
